import { ORGANIZATION_API_PATHS } from '../constants/apiPaths';
import axiosOrganizationInstance from '../organization/AxiosOrganizationInstance';
import { getAuthHeaders } from '../organization/organizationStorage';

export async function fetchAdminFoodSubscriptions(params = {}) {
  const res = await axiosOrganizationInstance.get(ORGANIZATION_API_PATHS.adminFoodSubscriptions, {
    headers: getAuthHeaders(),
    params,
  });
  return res?.data || { subscriptions: [], total: 0 };
}

export async function fetchAdminPickupSubscriptions(params = {}) {
  const res = await axiosOrganizationInstance.get(ORGANIZATION_API_PATHS.adminPickupSubscriptions, {
    headers: getAuthHeaders(),
    params,
  });
  return res?.data || { subscriptions: [], total: 0 };
}
